import numOfDaysInCurrentMonth from '../lib/numOfDaysInCurrentMonth';

const daysInCurrentMonth = (value) => {
  if (!value) {
    return false;
  }
  return parseInt(value, 10) <= numOfDaysInCurrentMonth();
};
export default daysInCurrentMonth;
